<template>
    <div class="tableHeader">
        <div class="sortableItem" @click="sortName"><p>
            Kunde
        </p>
            <i v-if="!nameSort" class="fa fa-sort-desc" aria-hidden="true"></i>
            <i v-if="nameSort" class="fa fa-sort-asc" aria-hidden="true"></i>
        </div>
        <div class="sortableItem" @click="sortDate"><p>
            zuletzt aktualisiert
        </p>
            <i v-if="!dateSort" class="fa fa-sort-desc" aria-hidden="true"></i>
            <i v-if="dateSort" class="fa fa-sort-asc" aria-hidden="true"></i>
        </div>
        <div class="sortableItem" @click="sortState"><p>
            Status
        </p>
            <i v-if="!stateSort" class="fa fa-sort-desc" aria-hidden="true"></i>
            <i v-if="stateSort" class="fa fa-sort-asc" aria-hidden="true"></i>
        </div>
        <div class="sortableItem" @click="sortGroup"><p>
            Gruppe
        </p>
            <i v-if="!groupSort" class="fa fa-sort-desc" aria-hidden="true"></i>
            <i v-if="groupSort" class="fa fa-sort-asc" aria-hidden="true"></i>
        </div>
        <div>Vorschau</div>
        <div>Aktionen</div>
    </div>
</template>

<script>
    export default {
        name: 'Tableheader',
        props: ['allClientMessages', 'userGroups'],
        data() {
            return {
                nameSort: false,
                dateSort: false,
                stateSort: false,
                groupSort: false,
            }
        },
        methods: {
            sortName: function () {
                if (this.nameSort) {
                    this.allClientMessages.sort(function (a, b) {
                        if (a.fullCustomerName > b.fullCustomerName) {
                            return -1;
                        }
                        if (a.fullCustomerName < b.fullCustomerName) {
                            return 1;
                        }
                        return 0;
                    })
                } else {
                    this.allClientMessages.sort(function (a, b) {
                        if (a.fullCustomerName < b.fullCustomerName) {
                            return -1;
                        }
                        if (a.fullCustomerName > b.fullCustomerName) {
                            return 1;
                        }
                        return 0;
                    })
                }
                this.nameSort = !this.nameSort;
            },
            sortDate: function () {
                if (this.dateSort) {
                    this.allClientMessages.sort(function (a, b) {
                        return new b.lastStatusUpdateTimestamp - a.lastStatusUpdateTimestamp;
                    });
                } else {
                    this.allClientMessages.sort(function (a, b) {
                        return a.lastStatusUpdateTimestamp - b.lastStatusUpdateTimestamp;
                    });
                }
                this.dateSort = !this.dateSort;
            },
            sortState: function () {
                if (this.stateSort) {
                    this.allClientMessages.sort((a, b) => {
                      let aVal;
                      let bVal;
                      switch (a.status) {
                            case "open":
                                aVal = 0;
                                break;
                            case "processed":
                                aVal = 1;
                                break;
                            case "closed":
                                aVal = 2;
                                break;
                        }

                        switch (b.status) {
                            case "open":
                                bVal = 0;
                                break;
                            case "processed":
                                bVal = 1;
                                break;
                            case "closed":
                                bVal = 2;
                                break;
                        }

                        if (aVal < bVal) return 1;
                        if (aVal > bVal) return -1;
                        else return 0;
                    })
                } else {
                    this.allClientMessages.sort((a, b) => {
                      let aVal;
                      let bVal;
                      switch (a.status) {
                            case "open":
                                aVal = 0;
                                break;
                            case "processed":
                                aVal = 1;
                                break;
                            case "closed":
                                aVal = 2;
                                break;
                        }

                        switch (b.status) {
                            case "open":
                                bVal = 0;
                                break;
                            case "processed":
                                bVal = 1;
                                break;
                            case "closed":
                                bVal = 2;
                                break;
                        }
                        if (aVal < bVal) return -1;
                        if (aVal > bVal) return 1;
                        else return 0;
                    })
                }
                this.stateSort = !this.stateSort;
            },
            sortGroup: function () {
                if (this.groupSort) {
                    this.allClientMessages.sort((a, b) => {
                        let groupnameA = "keine";
                        let groupnameB = "keine";

                        this.userGroups.forEach(group => {
                                if (a.groupId) {
                                    if (group.id === a.groupId) {
                                        groupnameA = group.name;
                                    }
                                }
                                if (b.groupId) {
                                    if (group.id === b.groupId) {
                                        groupnameB = group.name;
                                    }
                                }
                        });

                        if (groupnameA > groupnameB) {
                            return -1;
                        }
                        if (groupnameA < groupnameB) {
                            return 1;
                        }
                        if (groupnameA === groupnameB) {
                            return 0;
                        }
                    })
                } else {
                    this.allClientMessages.sort((a, b) => {
                        let groupnameA = "keine";
                        let groupnameB = "keine";

                        this.userGroups.forEach(group => {
                            if (a.groupId) {
                                if (group.id === a.groupId) {
                                    groupnameA = group.name;
                                }
                            }
                            if (b.groupId) {
                                if (group.id === b.groupId) {
                                    groupnameB = group.name;
                                }
                            }
                        });

                        if (groupnameA > groupnameB) {
                            return 1;
                        }
                        if (groupnameA < groupnameB) {
                            return -1;
                        }
                        if (groupnameA === groupnameB) {
                            return 0;
                        }
                    })
                }
                this.groupSort = !this.groupSort;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tableHeader {
        width: 100%;
        background-color: #ebebeb;
        padding: 10px 15px 10px 10px;
        border-radius: 7px;
        display: flex;
        font-weight: bold;
        flex-wrap: nowrap;
        margin-bottom: 20px;

        > div {
            display: flex;
            flex-direction: row;
            width: calc(16.6% - 5px);

            &.sortableItem {
                cursor: pointer;
            }

            i {
                margin-left: 5px;

                &.fa-sort-desc {
                    margin-top: 2px;
                }

                &.fa-sort-asc {
                    margin-top: 8px;
                }

            }

            p {
                margin: 0;
            }
        }
    }
</style>
